import { Box } from '@wishket/design-system';

import { Skeleton } from '@/shared/Components';

const RecentContentsSkeleton = () => {
  return (
    <Box className="grid grid-cols-1 gap-5 tablet:grid-cols-2">
      <Skeleton className="h-[160px] w-full desktop:h-[168px]" />
      <Skeleton className="h-[160px] w-full desktop:h-[168px]" />
    </Box>
  );
};

export default RecentContentsSkeleton;
